module.exports = __webpack_public_path__ + "static/media/logo-td-horizontal.c83f4896.png";